/**
 * Admin Settings sidebar configuration
 */
export default {
  pathPrefix: 'admin/settings',
  items: [
    {
      label: 'Onboarding',
      href: '/admin/settings/onboarding_flows',
      icon: 'fa-solid fa-clipboard-question',
      activePath: 'admin/settings/onboarding_flows'
    },
    {
      label: 'Team',
      href: '/admin/settings/system_users',
      icon: 'fa-solid fa-shield-halved',
      activePath: 'admin/settings/system_users',
      show: (store) => store.trueUserRoot
    },
    {
      label: 'Operations',
      href: '/admin/settings/operation_states',
      icon: 'fa-solid fa-gears',
      activePath: 'admin/settings/operation_states'
    },
    {
      label: 'Mobile Apps',
      href: '/admin/settings/mobile_apps',
      icon: 'fa-solid fa-mobile-screen',
      activePath: 'admin/settings/mobile_apps'
    }
  ]
}
